module.exports = __webpack_public_path__ + "img/memory_12.1e71627c.jpg";